// @flow
import * as React from 'react';
import ovalLoader from '../assets/images/oval-loader.svg';
import Container from './Container';

type TProps = {
  size: number,
  children?: React.Node,
  isLoading?: boolean,
};

export default function LoaderContainer(props: TProps): React.Node {
  return (
    <Container>
      {!props.isLoading ? props.children : (
        <Container flex centered>
          <img height={`${props.size}px`} src={ovalLoader} alt="" />
        </Container>
      )}
    </Container>
  );
}
